import styled from "styled-components";

const Divider = styled.div`
  margin: 1em 1.5em;
  border: 1px solid #282828;
`

export default Divider
